import { ActionList, ActionMenu, Box } from '@primer/react';
import { XIcon } from '@primer/octicons-react';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { hinhThucNopBomApi } from "../../api/hinhThucNopBom";
import { useCommonContext } from "../../contexts/common";
import { sf_hinhthucnopbom } from "../../models/response/category/sf_hinhthucnopbom";

type ICmbHinhThucNopBomProps = {
    isReadonly?: boolean,
    value?: number,
    width?: number,
    onValueChanged: (id: number, data?: sf_hinhthucnopbom) => void,
    className?: string,
    isShowClearButton?: boolean,
    preText?: string,
    stylingMode?: "outlined" | "filled" | "underlined",
    size?: "small" | "medium" | "large",
    dmCoSoId?: number,
    sf_hinhthucnopbom_dotgui?: string
}

const CmbHinhThucNopBom = (props: ICmbHinhThucNopBomProps) => {
    const [hinhThucNopBoms, setHinhThucNopBoms] = useState<sf_hinhthucnopbom[]>([]);
    
    const handleReloadHinhThucNopBoms = useCallback(async () => {
        const res = await hinhThucNopBomApi.selectAll();
        if (res.is_success) {
            var temp = res.data;
            temp = res.data.filter((x: any) => x.id > 0);
            if (props.sf_hinhthucnopbom_dotgui) {
                const htnb_ids = props.sf_hinhthucnopbom_dotgui.split(',')
                    .map(Number);
                temp = temp.filter((x: any) => htnb_ids.includes(x.id));
            }
            setHinhThucNopBoms(temp)
        }
    }, [props.sf_hinhthucnopbom_dotgui])
    
    useEffect(() => {
        handleReloadHinhThucNopBoms();
    }, [props.dmCoSoId, handleReloadHinhThucNopBoms])
    
    const selectedData = useMemo(() => {
        if (props.value && hinhThucNopBoms) {
            return hinhThucNopBoms.find(x => x.id === props.value)
        }
        return undefined
    }, [hinhThucNopBoms, props.value])
    
    const { translate } = useCommonContext();
    
    const handleClear = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        props.onValueChanged(0);
    };

    return (
        <div style={{ width: props.width ? `${props.width}px` : '100%' }}>
            <ActionMenu>
                <ActionMenu.Button
                    aria-label="Select payment period"
                    size={props.size}
                    disabled={props.isReadonly === true}
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                >
                    <span>{selectedData ? selectedData.name : translate("Chọn kỳ nộp")}</span>
                    {/* {props.isShowClearButton && selectedData && (
                        <Box
                            as="span"
                            onClick={handleClear}
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                ml: 1,
                                '&:hover': {
                                    color: 'fg.danger'
                                }
                            }}
                        >
                            <XIcon size={16} />
                        </Box>
                    )} */}
                </ActionMenu.Button>
                <ActionMenu.Overlay width="small">
                    <ActionList selectionVariant="single">
                        {hinhThucNopBoms && hinhThucNopBoms.filter(item => item && item.id).map((item) => {
                            return (
                                <ActionList.Item 
                                    key={item.id} 
                                    selected={props.value !== undefined && item.id === props.value}
                                    onSelect={() => {
                                        props.onValueChanged(item.id, item)
                                    }}
                                >
                                    {item.name}
                                </ActionList.Item>
                            );
                        })}
                    </ActionList>
                </ActionMenu.Overlay>
            </ActionMenu>
        </div>
    );
}

export default CmbHinhThucNopBom

